<template>
	<div class="b-table-sticky-header">
		<b-table id="table-giacenze" ref="GiacenzaTable" head-variant="light" class="sa-b-table" sticky-header striped
			hover stacked="lg" :items="magazzinoArticoliGiacenzaItems" :fields="articoliFields" selectable
			select-mode="single" @row-selected="onRowSelectedArticoliItems" :tbody-tr-class="rowClassCustom">
			<template #cell(index)="data">
				{{ data.index + 1 }}
			</template>
			<template #cell(matricoleLotti)="row">
				{{ row.item.gestioneMatricole ? "Gestione Matricole" : row.item.gestioneLottiScadenze ?
					"Gestione Lotti"
					: "Non Prevista" }}
			</template>
			<template #cell(umId)="row">
				{{ getDescrizioneMultiploUnitaMisura(row.item.umId) }}
			</template>
			<template #cell(actions)="row">
				<b-button v-if="row.item.gestioneLottiScadenze || row.item.gestioneMatricole" size="sm"
					v-b-tooltip.hover title="Info Matricole Lotti" variant="outline-info"
					@click="onClickInfoLottiMatricole(row)" class="mr-1 no-text">
					<font-awesome-icon icon="info"> </font-awesome-icon>
				</b-button>
			</template>
			<template #row-details>
				<div> Stesso Lotto</div>
				<b-form>
					<div class="sa-form-section sa-search-box">
						<b-row class="p-3">
							<b-col cols="12" xs="12" sm="12" md="3" lg="2" xl="2">
								<label class="sa-search-box-label">Codice Articolo</label>
								<div class="sa-search-search-wrapper">
									<input class="sa-search-box-input" v-model="lottoMatricola.codiceArticolo"
										placeholder="Codice Articolo" />
								</div>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
								<label class="sa-search-box-label">Lotto/Matricola</label>
								<div class="sa-search-search-wrapper">
									<input class="sa-search-box-input" v-model="lottoMatricola.lottoMatricola"
										placeholder="Lotto/Matricola" />
								</div>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
								<label class="sa-search-box-label">Qtn</label>
								<div class="sa-search-search-wrapper">
									<input class="sa-search-box-input" v-model="lottoMatricola.quantita"
										placeholder="Quantita" />
								</div>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
								<label class="sa-search-box-label">Data Produzione</label>
								<div class="sa-search-search-wrapper">
									<date-picker format="DD/MM/YYYY" value-type="timestamp" class="sa-badge-data"
										v-model="lottoMatricola.dataOraProduzione" type="date"></date-picker>
								</div>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
								<label class="sa-search-box-label">Data Scadenza</label>
								<div class="sa-search-search-wrapper">
									<date-picker format="DD/MM/YYYY" value-type="timestamp" class="sa-badge-data"
										v-model="lottoMatricola.dataOraScadenza" type="date"></date-picker>
								</div>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
								<div style="height: 100% !important; width: 100%; align-content: center; margin: 10px;">
									<b-button size="sm"
										variant="btn btn-outline-success waves-effect waves-light width-sm no-text"
										style="margin-right: 5px" @click="onAddLottoMatricola()">
										<b-icon icon="plus"></b-icon>
									</b-button>
								</div>
							</b-col>
						</b-row>
					</div>
				</b-form>
				<hr />
				<div class="sa-badge-group-lotti">
					<div :class="{ 'sa-badge': true, 'sa-badge-ft-active-class': isBadgeActiveLotto(item), 'sa-badge-ft-disable-class': isDisabledSelezione(item) }"
						v-for="item, index of getListaMatricoleLotti()" :key="index" @click="onSelezionaLotto(item)">
						<div>
							<span class="sa-badge-label">Lotto/Matricola:</span>
							<span class="sa-badge-data">{{ item.lottoMatricola }}</span>
							<hr />
						</div>
						<div>
							<span class="sa-badge-label">Qtn:</span>
							<span class="sa-badge-data">{{ item.quantita }}</span>
							<hr />
						</div>
						<div>
							<span class="sa-badge-label">Produzione:</span>
							<span class="sa-badge-data">{{ formatDate(item.dataOraProduzione)
							}}</span>
							<hr />
						</div>
						<div>
							<span class="sa-badge-label">Scadenza:</span>
							<span class="sa-badge-data">{{ formatDate(item.dataOraScadenza)
							}}</span>
							<hr />
						</div>

						<div style="text-align: end; align-content: end" v-if="operazione == 1">
							<b-button size="sm"
								variant="btn btn-outline-danger waves-effect waves-light width-sm no-text"
								style="margin-right: 5px" @click="onRemoveLottoScademza(index)">
								<b-icon icon="trash"></b-icon>
							</b-button>
						</div>
					</div>
				</div>
			</template>
		</b-table>
	</div>
</template>

<script>
import toast from '../../../template/layout/utility/sa-toast';
import ContabilitaMixin from '../../contabilita/mixins/ContabilitaMixin';
import UtilityMixin from '../../utility/UtilityMixin';
import MagazzinoMixins from '../mixins/MagazzinoMixins';
import DatePicker from "vue2-datepicker";

export default {
	components: { DatePicker },
	mixins: [ContabilitaMixin, MagazzinoMixins, UtilityMixin],

	mounted() {
		this.getPresidio();
	},
	data() {
		return {
			presidio: {},
			operazione: 0,
			rigaDocumento: {
				lottiScadenze: []
			},
			filtro: {
				page: 1,
				forPage: 50
			},
			isModifica: false,
			itemsDetails: {},
			arrays: {
				articolo: null,
				lottoMatricoleSelezionate: [
				]
			},
			lottoMatricola: {
				id: "-1",
				idArticolo: null,
				codiceArticolo: null,
				lottoMatricola: null,
				quantita: 1,
				dataOraScadenza: new Date().getTime(),
				dataOraProduzione: new Date().getTime(),
			},
		};
	},
	watch: {
		magazzinoArticoliGiacenzaRecordNumbers: function (params) {
			this.$emit("updateRowNumberGiacenza", params)

		},
		magazzinoArticoliGiacenzaItems: function (params) {
			if (params.length == 1) {
				this.$nextTick(() => {
					if (this.$refs.GiacenzaTable) {
						console.log(this.isModifica);

						if (!this.isModifica) {
							this.$refs.GiacenzaTable.selectRow(0);
							this.magazzinoArticoliGiacenzaItems[0]._showDetails = true;
						}
					}
				});

			}

		}
	},
	computed: {
		isOperazioneScarico() {
			return this.operazione == "-1";
		}
	},
	methods: {
		setFiltroRigaDocumentoOperazione(filtro = null, rigaDocumento, operazione) {
			this.operazione = operazione;
			this.rigaDocumento = rigaDocumento;
			if (filtro) {
				this.filtro.page = filtro.page;
				this.filtro.forPage = filtro.forPage
			}
			this.loadData();
		},
		setRigaDocumento(rigaDocumento) {
			this.rigaDocumento = rigaDocumento;
		},
		onModificaRow(rowSelezionata) {
			this.isModifica = true;
			console.log("modifica", rowSelezionata);
		},
		onRowSelectedArticoliItems(item) {
			this.arrays.articolo = item;
			if (item[0]) {
				let articolo = item[0];
				this.isGestioneLottoMatricole = articolo.gestioneMatricole || articolo.gestioneLottiScadenze
				if (this.isGestioneLottoMatricole) {
					this.$set(articolo, '_showDetails', true);
					this.lottoMatricola.idArticolo = articolo.id;
					this.lottoMatricola.codiceArticolo = articolo.codiceArticolo;
				}
			}

			this.$emit("onRowSelectedArticoliItems", item)
		},
		getDescrizioneMultiploUnitaMisura() { },
		onClickInfoLottiMatricole(row) {
			this.$refs.GiacenzaTable.selectRow(row.index);
			row.toggleDetails();
		},
		getListaMatricoleLotti() {

			return this.rigaDocumento.lottiScadenze;

		},
		onRemoveLottoScademza(index) {
			this.rigaDocumento.lottiScadenze.splice(index, 1);
			this.emitLottoMatricola();
		},

		loadData() {
			this.filtro.nomeArticolo = this.rigaDocumento.descrizione ? this.rigaDocumento.descrizione.toUpperCase() : "";
			this.filtro.codiceArticolo = this.rigaDocumento.codiceArticolo;
			this.filtro.codiceAzienda = this.presidio.codiceStruttura;
			this.magazzinoArticoliGiacenzeLoadData(this.filtro);
		},
		loadDataMatricoleLotti(filtro) {
			this.magazzinoArticoloLottiLoadResource(filtro);
		},
		getPresidio() {
			let tmpPresidio = window.localStorage.getItem("presidio");
			if (tmpPresidio) {
				this.presidio = JSON.parse(tmpPresidio);
			}
		},
		rowClassCustom(item, type) {
			if (!item || type !== 'row') return
			if (item.giacenza < 0) return 'articolo-row-giacenza-color-danger'
		},
		isDisabledSelezione(element) {
			return element.giacenza == 0;
		},
		isBadgeActiveLotto(item) {
			const index = this.arrays.lottoMatricoleSelezionate.findIndex((element) => element.lottoMatricola === item.lottoMatricola);
			return index == -1 ? false : true;
		},
		onAddLottoMatricola() {
			let validation = this.validazioneLottoMatricola();
			if (!validation.esito) {
				this.generaBtoast(validation);
				return;
			}
			if (this.lottoMatricola) {
				let matricolaLotto = JSON.parse(JSON.stringify(this.lottoMatricola));
				this.rigaDocumento.lottiScadenze.push(matricolaLotto);
				this.resetLottoMatricolaRiga();
			}
			this.emitLottoMatricola();
		},
		emitLottoMatricola() {
			this.$emit("onAddLottoMatricola", this.rigaDocumento.lottiScadenze);
		},

		resetLottoMatricolaRiga() {
			this.lottoMatricola = {
				id: "-1",
				idArticolo: null,
				codiceArticolo: null,
				lottoMatricola: null,
				quantita: 1,
				dataOraScadenza: new Date().getTime(),
				dataOraProduzione: new Date().getTime(),
			};
			if (this.rigaDocumento) {
				this.lottoMatricola.idArticolo = this.rigaDocumento.idArticolo;
				this.lottoMatricola.codiceArticolo = this.rigaDocumento.codiceArticolo;
			}
		},
		onSelezionaLotto(lottoMatricola) {
			if (this.operazione == -1) {
				if (this.isBadgeActiveLotto(lottoMatricola)) {
					const index = this.arrays.lottoMatricoleSelezionate.findIndex((element) => element.lottoMatricola === lottoMatricola.lottoMatricola);
					this.arrays.lottoMatricoleSelezionate.splice(index, 1);
				} else {
					if (lottoMatricola.giacenza > this.rigaDocumento.quantita) {
						this.$bvToast.toast("Non è possibile selezionare questo lotto", {
							title: "Attenzione!",
							autoHideDelay: 5000,
							variant: "danger",
						});
						return;
					}
					if (this.arrays.lottoMatricoleSelezionate.length < this.rigaDocumento.quantita) {
						this.arrays.lottoMatricoleSelezionate.push(lottoMatricola);
						this.$emit("onSelectedLottoMatricola", this.arrays.lottoMatricoleSelezionate);
					} else {
						this.$bvToast.toast(`Puoi selezionare al massimo ${this.rigaDocumento.quantita} righe`, {
							title: "Attenzione!",
							autoHideDelay: 5000,
							variant: "danger",
						});
					}
				}
			}
		},
		generaBtoast(validation) {
			toast.validation(validation)
		},
		validazioneLottoMatricola() {
			let esito = true;
			let msg = "";
			let articoloSelezionato = this.arrays.articolo[0];
			if (articoloSelezionato) {
				if (articoloSelezionato.gestioneLottiScadenze) {
					if (this.lottoMatricola.dataOraProduzione >= this.lottoMatricola.dataOraScadenza) {
						msg += "Lotto Data Ora produzione non può essere superiore o uguale alla data scadenza. ! #";
						esito = false;
					}
				}
				if (this.lottoMatricola.lottoMatricola == null || this.lottoMatricola.lottoMatricola.trim() == "") {
					msg += articoloSelezionato.gestioneMatricole ? "Matricola " : " Lotto ";
					msg += " non valido/a ! #";
					esito = false;
				}
				if (this.lottoMatricola.quantita <= 0) {
					msg += articoloSelezionato.gestioneMatricole ? "Matricola " : " Lotto ";
					msg += " quantita non può essere 0 o inferiore. ! #";
					esito = false;
				}
			} else {
				msg += "Articolo non selezionato! #";
				esito = false;
			}

			if (this.rigaDocumento.lottiScadenze.length == 0) {
				console.log(this.rigaDocumento);

				if (this.lottoMatricola.quantita > this.rigaDocumento.quantita) {
					msg += articoloSelezionato.gestioneMatricole ? "Matricola " : " Lotto ";
					msg += " quantita non può essere superiore della quantita riga. ! #";
					esito = false;
				}
			}


			return { esito: esito, msg: msg };
		},

	},
};
</script>

<style scoped>
.sa-badge-group-lotti {
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
	margin-top: 15px;
}

.sa-badge {
	flex: 1 1 400px;
	max-width: calc(25% - 8px);
}

.sa-badge-insert {
	display: flex;
	gap: 20px;
	width: 100%;
	align-items: flex-end;
	margin-bottom: 15px;
}

.sa-badge-insert>div {
	flex: 1;
	min-width: 0;
}

.sa-badge-insert .sa-badge-data {
	width: 100%;
}

.sa-badge:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
	background-color: rgba(255, 255, 255, 0.651);
}

.sa-badge-ft-disable-class {
	background-color: var(--sa-data-text-color);
	cursor: not-allowed;
	border-left: 3px solid #a71d2a;
}

.sa-badge-ft-active-class {
	transform: translateY(-2px);
	box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
	border: 1px solid var(--bg-sidebar) !important;
	border-color: var(--bg-sidebar) !important;
	background-color: var(--bg-button-press-color);
}

.sa-badge-ft-active-class:hover {
	box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
	border: 1px solid var(--bg-sidebar) !important;
	border-color: var(--bg-sidebar) !important;
	background-color: var(--bg-button-press-color);
}

.sa-badge-ft-disable-class:hover {
	transform: translateY(0px);
}
</style>
